import type { Colors } from '@/components/ui'
import { includes } from '@/helpers'

export type ButtonType = 'solid' | 'bordered' | 'link'

export type ButtonTextSize = 12 | 14 | 16 | 19

export type ButtonSize = 'small' | 'medium'

// Should be subset of ColorsV
const buttonColors = [
    'var(--slate)',
    'var(--green)',
    'var(--taaffeite)',
    'var(--blue)',
    'var(--red)',
    'var(--sage)',
    'var(--blush)',
    'var(--stone)',
    'var(--stone-2)',
    'var(--stone-3)',
    'var(--white)',
] as const

export type ButtonColors = Extract<Colors, (typeof buttonColors)[number]>

export function isButtonColor(color: unknown): color is ButtonColors {
    return includes(buttonColors, color)
}

export function getColorForBackground(color: ButtonColors): Colors {
    switch (color) {
        case 'var(--sage)':
        case 'var(--blush)':
        case 'var(--stone)':
        case 'var(--stone-2)':
        case 'var(--stone-3)':
        case 'var(--white)':
            return 'var(--slate)'
        default:
            return 'var(--white)'
    }
}
